"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shared = _interopRequireDefault(require("./shared"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _hex2rgba = _interopRequireDefault(require("hex2rgba"));

var _edenStyleConstants = require('../../../../eden-style-constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Component = _styledComponents.default.button.withConfig({
  componentId: "owe3k7-0"
})(["", ";color:", ";background:linear-gradient( 150deg,", ",", " ),", ";&:hover{background:", ";color:", ";}&:active{background:linear-gradient( 150deg,rgba(255,255,255,0),rgba(255,255,255,0.3) ),", ";}"], _shared.default, _edenStyleConstants.white, (0, _hex2rgba.default)(_edenStyleConstants.white, 0.3), (0, _hex2rgba.default)(_edenStyleConstants.white, 0), _edenStyleConstants.danger60, _edenStyleConstants.danger60, _edenStyleConstants.white, _edenStyleConstants.danger60);
/**
 * A Danger button can be used to warn the user of a potentially destructive interaction, such as deleting an item.
 */


const Danger = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(Component, _extends({}, props, {
  ref: ref,
  as: props.disabled ? "button" : props.href ? "a" : "button"
}), props.children));

Danger.defaultProps = {
  type: "button"
};
Danger.displayName = "Danger";
Danger.propTypes = {
  /** The button contents */
  children: _propTypes.default.node.isRequired,

  /** Whether to apply styles that help the button stand out on a dark background */
  inverted: _propTypes.default.bool,

  /** Whether to apply smaller styles */
  small: _propTypes.default.bool,

  /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
  type: _propTypes.default.string,

  /** If the button should expand to the full width of its parent */
  fullWidth: _propTypes.default.bool,

  /** If the button should be disabled */
  disabled: _propTypes.default.bool,

  /** The link that the button should navigate to on click */
  href: _propTypes.default.string
};
var _default = Danger;
exports.default = _default;